import {Alert, Card, Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router";
import {ProductsApi} from "../../api/ProductsApi";
import {useAsync} from "../../components/useAsync";
import {ErrorAlert} from "../../components/ErrorAlert";
import {LoadingSpinner} from "../../components/LoadingSpinner";
import {usePageMeta} from "../../components/usePageMeta";
import {accentProps} from "../../components/accent";
import {ProductPrices} from "./ProductPrices";
import {htmlSummary} from "../../components/sanitizeHtml";
import {productList} from "../../structuredData";
import {TrademarkNotices, trademarksIn} from "../../components/TrademarkNotices";
import {format, products as messages} from "../../i18n";

// The products, a showcase page (layout/showcasePages.ts): a card for each, in its color.
export function ProductCatalogPage() {
    const {data: products, error, loading} = useAsync(() => ProductsApi.getPublished(), []);
    usePageMeta({ title: messages.catalog.title, description: messages.catalog.description, jsonLd: products && productList(products) });

    return (
        <Container className="showcase-section showcase-end">
            <h1 className="showcase-title">{messages.catalog.title}</h1>
            <p className="showcase-lead mb-5">{messages.catalog.description}</p>
            <ErrorAlert error={error}/>
            {loading && !products && <LoadingSpinner/>}
            {products?.length === 0 && <Alert variant="secondary">{messages.catalog.none}</Alert>}
            <Row className="g-4">
                {products?.map(product => (
                    <Col key={product.id} md={6} lg={4}>
                        <Card className="showcase-card h-100" {...accentProps(product.accentColor)}>
                            {product.images[0] && <Card.Img variant="top" src={product.images[0].url} alt={product.images[0].altText} className="product-card-image"/>}
                            <Card.Body className="d-flex flex-column p-4">
                                <Card.Title>
                                    <Link to={`/products/${encodeURIComponent(product.sku)}`} className="stretched-link text-reset text-decoration-none">{product.name}</Link>
                                    {product.beta && <span className="badge text-bg-info align-middle fs-6 ms-2">{messages.closedBeta}</span>}
                                </Card.Title>
                                <Card.Text className="text-body-secondary">{htmlSummary(product.description)}</Card.Text>
                                <div className="mt-auto d-flex justify-content-between align-items-end">
                                    <ProductPrices prices={product.prices}/>
                                    {product.currentVersion && <span className="small text-body-secondary">{format(messages.catalog.version, { version: product.currentVersion.version })}</span>}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
            {products && <TrademarkNotices marks={trademarksIn(...products.map(x => x.description))} className="mt-5"/>}
        </Container>
    );
}
